import { Button, FormInput } from "semantic-ui-react";

export const MultipleTextFieldFormComponent = (props: {
  props: MultipleTextFieldFormComponentProps;
  data: any;
  setData: any;
}) => {
  return (
    <>
      <label>{props.props.label}</label>
      <br />
      {props.data[props.props.key].map((value: string, index: number) => (
        <FormInput
          className={"multiple-text-field-input-" + index}
          key={index}
          fluid
          placeholder={props.props.placeholder}
          value={props.data[props.props.key][index].name}
          onChange={(e) => {
            props.setData({
              ...props.data,
              [props.props.key]: props.data[props.props.key].map(
                (item: any, i: number) =>
                  i === index ? { ...item, name: e.target.value } : item,
              ),
            });
          }}
        />
      ))}
      <Button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          props.setData({
            ...props.data,
            [props.props.key]: [...props.data[props.props.key], { name: "" }],
          });
        }}
      >
        Add Item
      </Button>
    </>
  );
};

export type MultipleTextFieldFormComponentProps = {
  type: "multiple_text_fields";
  key: string;
  label: string;
  placeholder: string;
};
